import React from 'react';
import PropTypes from 'prop-types';

import InputInlineEditable from 'core/gd-components/input-inline-editable/input-inline-editable';
import ColorSelector from "core/gd-components/color/selector/selector";


export default class ItemRow extends React.Component {
    static propTypes = {
        item: PropTypes.object.isRequired,

        colorSelectionEnabled: PropTypes.bool,

        onItemRename: PropTypes.func,
        onItemChangeColor: PropTypes.func,
        onDeleteClick: PropTypes.func
    };

    static defaultProps = {
        colorSelectionEnabled: false
    }

    state = {
        isEditing: false
    };

    focus = () => {
        this.input.focus();
    }

    onInputFocus = () => {
        this.setState({
            isEditing: true
        }, ()=>{
            if (this.props.onEditState) this.props.onEditState(this.state.isEditing);
        });
    };

    onInputBlur = () => {
        const newValue = this.input.getValue();

        this.setState({
            isEditing: false
        },()=>{
            if (this.props.onEditState) this.props.onEditState(this.state.isEditing);
            if (this.inputChanged) {
                this.inputChanged = false;
                this.props.onItemRename(this.props.item.value, newValue);
            }
        })
    };

    onInputChange = (newLabel) => {
        if (this.props.item.label !== newLabel) {
            this.inputChanged = true;
            this.props.item.label = newLabel;
        }
    }

    onChangeColor = (newColor) => {
        if (this.props.onItemChangeColor && this.props.item.color !== newColor) this.props.onItemChangeColor(this.props.item.value, newColor);
    }

    onDeleteClick = (e) => {
        if (!this.props.onDeleteClick) return;

        e.stopPropagation();
        this.props.onDeleteClick(this.props.item);
    };

    render() {
        const classes = Classes("ui5-cf-edit-option", {
            'with-color': this.props.colorSelectionEnabled,
            'hover': this.props.dndHover
        });

        return (
            <div className={classes}>
                <div className="handle"><div className="icon i5-dnd"/></div>
                <div className="input">
                    <InputInlineEditable ref={r=>this.input = r}
                                         className="value"
                                         placeholder=""
                                         value={this.props.item.label}
                                         onFocus={this.onInputFocus}
                                         onBlur={this.onInputBlur}
                                         onChange={this.onInputChange}/>

                    {this.props.colorSelectionEnabled &&
                    <ColorSelector className="color-selector" value={this.props.item.color} allowSelectEmpty={true} onChange={this.onChangeColor}/>}
                </div>

                {this.props.onDeleteClick &&
                <div className="action"><div className="button gd-btn-circle-delete-red-18" onClick={this.onDeleteClick}/></div>}
            </div>
        );
    }
}
